import api from '../../../axios/axios-api'

export default {
  async fetchTiposDocumentos(context) {
    if (context.state.hasFetched) return
    context.commit('setLoadError', null)
    try {
      const { data } = await api.get('/taxonomy/tipos-documentos')
      context.commit('setTiposDocumento', Array.isArray(data) ? data : [])
    } catch (e) {
      context.commit('setLoadError', e)
      context.commit('setTiposDocumento', [])
    } finally {
      context.commit('setHasFetched', true)
    }
  },
  async fetchLocalidadesYBarriosTaxonomia(context) {
    if (context.state.geoTaxLoaded) return
    context.commit('setGeoTaxLoadError', null)
    try {
      const [locRes, barRes] = await Promise.all([
        api.get('taxonomy/localidades'),
        api.get('taxonomy/barrios'),
      ])
      const locs = (Array.isArray(locRes.data) ? locRes.data : []).filter(
        (x) => x?.id > 0 && x?.value,
      )
      const bars = (Array.isArray(barRes.data) ? barRes.data : []).filter(
        (x) => x?.id > 0 && x?.value,
      )
      context.commit('setLocalidadesTaxonomia', locs)
      context.commit('setBarriosTaxonomia', bars)
    } catch (e) {
      context.commit('setGeoTaxLoadError', e)
      context.commit('setLocalidadesTaxonomia', [])
      context.commit('setBarriosTaxonomia', [])
    } finally {
      context.commit('setGeoTaxLoaded', true)
    }
  },
}
